import { Container, Row, Col } from "react-bootstrap";
import { Box, TextField, Typography, Button } from "@mui/material";
import mailBox from "../Assets/Images/newsletter-img.jpg";
const NewsLetterFooter = () => {
  return (
    <>
      <Box className="NewsletterBox">
        <Container style={{ zIndex: 2, position: "relative", padding: "60px" }}>
          <Row>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Box className="NewsletterLeft">
                <Typography component="h2">
                  Subscribe to our Newsletter
                </Typography>
                <Typography component="p">
                 Stick with the latest updates and exclusive offers! Get your hands on exciting discounts.
                </Typography>
              </Box>
            </Col>

            <Col lg={6} md={6} sm={12} xs={12}>
              <Box className="NewsletterRight">
                <Box>
                  <Typography variant="h2">Newsletter's</Typography>
                </Box>
                <Box component="form" className="NewsletterForm">
                  <TextField
                    placeholder="Enter your email"
                    fullWidth
                    size="medium"
                    multiline
                    variant="outlined"
                    InputLabelProps={{
                      shrink: false, // still needed in case you use `label`, but we skip it
                    }}
                    InputProps={{
                      sx: {
                        borderRadius: 0,
                        border:'1px solid #ccc',
                        bgcolor: "#fff",
                        "&:focus-within": {
                          bgcolor: "#f0f0f0", // light gray background on focus
                          color: "#000", // optional: change text color on focus
                        },
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 0,
                        "& fieldset": {
                          borderRadius: 0,
                        },
                        "&:hover fieldset": {
                          borderColor: "#888",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#999",
                        },
                      },
                    }}
                  />

                  <Button variant="text">Subscribe</Button>
                </Box>
              </Box>
            </Col>
          </Row>
        </Container>
      </Box>
    </>
  );
};

export default NewsLetterFooter;
